import PropTypes from 'prop-types';
import CruiseDetails from '../CruiseDetails';
import CruiseInformation from '../CruiseInformation';

const CruiseInformationWithDetails = ({
  itinerary,
  selectedItineraryRow,
  tripId,
  onModalClose,
  doHideAllRows,
  doShowPrice,
  tripRoomSearchInput,
}) => (
  <>
    <CruiseInformation
      itineraryId={selectedItineraryRow.itineraryId}
      selectedItineraryRow={selectedItineraryRow}
      cruiseItinerary={itinerary}
      doHideAllRows={doHideAllRows}
    />
    <CruiseDetails
      cruiseItinerary={itinerary}
      tripId={tripId}
      onModalClose={onModalClose}
      itineraryId={selectedItineraryRow.itineraryId}
      selectedItineraryRow={selectedItineraryRow}
      doShowPrice={doShowPrice}
      tripRoomSearchInput={tripRoomSearchInput}
    />
  </>
);

CruiseInformationWithDetails.propTypes = {
  itinerary: PropTypes.shape({}),
  selectedItineraryRow: PropTypes.objectOf(PropTypes.objectOf),
  tripId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onModalClose: PropTypes.func,
  doHideAllRows: PropTypes.bool,
  doShowPrice: PropTypes.bool,
  tripRoomSearchInput: PropTypes.arrayOf(PropTypes.shape()),
};

CruiseInformationWithDetails.defaultProps = {
  itinerary: undefined,
  selectedItineraryRow: undefined,
  tripId: undefined,
  onModalClose: undefined,
  doHideAllRows: false,
  doShowPrice: true,
  tripRoomSearchInput: undefined,
};

export default CruiseInformationWithDetails;
